export default class AdesaoValidationModel {
    id: number | null;
    nome: string | null;
    cpf: string | null;
    id_contrato: number | null;
    categoria: string | null;
    valor: string | null;

    constructor(
        id: number | null,
        nome: string | null,
        cpf: string | null,
        id_contrato: number | null,
        categoria: string | null,
        valor: string | null
    ) {
        this.id = id;
        this.nome = nome;
        this.cpf = cpf;
        this.id_contrato = id_contrato;
        this.categoria = categoria;
        this.valor = valor;
    }

    static fromApiResponse(data: any): AdesaoValidationModel {
        return new AdesaoValidationModel(
            data.id || null,
            data.nome || null,
            data.cpf || null,
            data.id_contrato || null,
            data.categoria || null,
            data.valor || null,
        );
    }

    static fromApiResponseArray(dataArray: any[]): AdesaoValidationModel[] {
        return dataArray.map(data => AdesaoValidationModel.fromApiResponse(data));
    }
}